import { get } from '@kit/utils/APIV1.js'

export const bySlug = async(slug, short) => {
  return get(`team/${slug}/${short ? 'short' : 'long' }`)
}
export const all = async(short) => {
  return get(`teams/all/${short ? 'short' : 'long' }`)
}